import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
export const Logo = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1bb353u0"
} : {
  target: "e1bb353u0",
  label: "Logo"
})(process.env.NODE_ENV === "production" ? {
  name: "1c55ilo",
  styles: "height:min-content"
} : {
  name: "1c55ilo",
  styles: "height:min-content/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkxvZ28uanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQytCIiwiZmlsZSI6IkxvZ28uanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5leHBvcnQgY29uc3QgTG9nbyA9IHN0eWxlZC5kaXYgYFxuICBoZWlnaHQ6IG1pbi1jb250ZW50O1xuYDtcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPUxvZ28uanMubWFwIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});